import BokalSourage from 'bokal-sourage';

export default new BokalSourage('sd__');
